export enum SiteContext {
  Blueparrott = 'blueparrott',
  Jabra = 'jabra',
}
